import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=b6a85f36&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=b6a85f36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a85f36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6a85f36')) {
      api.createRecord('b6a85f36', component.options)
    } else {
      api.reload('b6a85f36', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=b6a85f36&scoped=true&", function () {
      api.rerender('b6a85f36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27LnDkt6wb5zl/JS/comp/Voucher.vue"
export default component.exports